import React, { useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from './AuthContext';
import CustomSignIn from './CustomSignIn';
import CustomSignUp from './CustomSignUp';
import ConfirmSignUp from './ConfirmSignUp';
import ForgotPassword from './ForgotPassword';
import config from '../../conf/config';

const AuthenticatedApp = ({ children }) => {
  const { user, loading } = useAuth();
  const [authState, setAuthState] = useState('signIn');
  const [signUpEmail, setSignUpEmail] = useState('');

  const handleStateChange = (newState, email = '') => {
    setAuthState(newState);
    if (email) setSignUpEmail(email);
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: 'background.default',
          gap: 2
        }}
      >
        <CircularProgress size={48} />
        <Typography variant="body1" color="text.secondary">
          Loading...
        </Typography>
      </Box>
    );
  }

  if (!user) {
    switch (authState) {
      case 'signUp':
        // Block signup if disabled - redirect to sign in
        if (!config.features.SIGNUP_ENABLED) {
          return <CustomSignIn onStateChange={handleStateChange} />;
        }
        return <CustomSignUp onStateChange={handleStateChange} />;
      case 'confirmSignUp':
        return <ConfirmSignUp onStateChange={handleStateChange} username={signUpEmail} />;
      case 'forgotPassword':
        return <ForgotPassword onStateChange={handleStateChange} />;
      case 'signIn':
      default:
        return <CustomSignIn onStateChange={handleStateChange} />;
    }
  }

  return children;
};

export default AuthenticatedApp;